/* WonderBuddy homepage - shared behaviour for all wb-home-* sections.
   Safe to load once per section: everything below is idempotent. */
(function () {
  if (window.wbHomeInit) { return; }
  window.wbHomeInit = true;

  /* Tell the stylesheet that JS is alive. Until this class exists the .reveal
     elements stay fully visible, so a blocked script can never blank the page. */
  document.documentElement.classList.add('wb-js');

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- scroll reveal ---------------------------------------------------- */
  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
  }

  function reveal(scope) {
    var nodes = (scope || document).querySelectorAll('.wb-home .reveal:not(.visible)');
    Array.prototype.forEach.call(nodes, function (el) {
      if (io) { io.observe(el); } else { el.classList.add('visible'); }
    });
  }

  /* ---- click-to-load reels ---------------------------------------------
     The markup ships a poster image and an inert <template>. Browsers do not
     fetch, parse or preload anything inside a <template>, so an uploaded video
     costs nothing until someone taps play - at which point the player is built
     and started inside the click, which is what keeps autoplay allowed.

     For an embedded (YouTube/Vimeo) reel we open the connection to the embed
     host on first hover instead, so the handshake is already done by the time
     the tap lands. Doing that in the page <head> would cost every visitor a
     connection they may never use. */
  function warm(url) {
    var origin;
    try { origin = new URL(url, location.href).origin; } catch (e) { return; }
    if (document.querySelector('link[rel="preconnect"][href="' + origin + '"]')) { return; }
    var l = document.createElement('link');
    l.rel = 'preconnect';
    l.href = origin;
    l.crossOrigin = '';
    document.head.appendChild(l);
  }

  function reels(scope) {
    var nodes = (scope || document).querySelectorAll('.wb-home .testimonial-reel.has-video');
    Array.prototype.forEach.call(nodes, function (reel) {
      if (reel.dataset.wbReel) { return; }
      reel.dataset.wbReel = '1';

      var tpl = reel.querySelector('.reel-source');
      var btn = reel.querySelector('.reel-play');
      if (!tpl || !btn || !tpl.content) { return; }

      var embed = tpl.getAttribute('data-embed');
      if (embed) {
        reel.addEventListener('pointerenter', function () { warm(embed); }, { once: true });
      }

      btn.addEventListener('click', function () {
        reel.classList.add('is-playing');
        reel.appendChild(tpl.content.cloneNode(true));
        btn.remove();
        var v = reel.querySelector('video');
        if (v) { v.play().catch(function () {}); }
        var f = reel.querySelector('iframe');
        if (f && f.src.indexOf('autoplay') === -1) {
          f.src += (f.src.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1';
        }
      });
    });
  }

  /* ---- carousels --------------------------------------------------------
     CSS decides when a carousel is active (below 900px, or always for the
     video strip). This code only builds the arrows and dots from the real
     card count, so the controls can never disagree with the layout. */
  function arrow(dir) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'wb-carousel-arrow';
    b.setAttribute('aria-label', dir < 0 ? 'Previous' : 'Next');
    b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">' +
      (dir < 0 ? '<path d="m15 5-7 7 7 7"/>' : '<path d="m9 5 7 7-7 7"/>') + '</svg>';
    return b;
  }

  function carousel(root) {
    if (root.dataset.wbBound) { return; }
    root.dataset.wbBound = '1';

    var viewport = root.querySelector('.wb-carousel-viewport');
    var track = viewport && viewport.firstElementChild;
    if (!track) { return; }

    var originals = Array.prototype.slice.call(track.children);
    if (originals.length < 2) { return; }

    /* Opt-in per carousel via data-wb-carousel-loop. Everything below this
       block is unchanged for the carousels that do not set it. */
    var loop = root.hasAttribute('data-wb-carousel-loop');
    var realCount = originals.length;
    var cloneCount = 0;
    var cards = originals;

    if (loop) {
      /* Endless scroll: clone a buffer of cards onto both ends of the track
         so there is always real content to scroll into, then silently jump
         back into the real range once the scroll settles (see settle() below)
         - the visitor never sees the seam. Buffer is capped at the real card
         count so a 2-product row does not get cloned into something absurd. */
      cloneCount = Math.min(realCount, 8);

      /* Clones are duplicates of cards that are already on screen, so they must
         never carry the scroll-reveal animation. .reveal starts at opacity 0 and
         only clears when the IntersectionObserver above sees the element - but
         that observer was handed the ORIGINAL cards before this cloning ran, so
         a clone is never watched by anything and stays invisible for good. The
         row then scrolls out of the real cards and into a stretch of nothing,
         which is the blank space at the end of the loop. Clearing reveal and
         marking them visible makes every clone paint immediately. */
      function buffer(c) {
        var clone = c.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('tabindex', '-1');
        clone.classList.remove('reveal');
        clone.classList.add('visible');
        var hidden = clone.querySelectorAll('.reveal');
        for (var h = 0; h < hidden.length; h++) {
          hidden[h].classList.remove('reveal');
          hidden[h].classList.add('visible');
        }
        return clone;
      }

      var headFrag = document.createDocumentFragment();
      originals.slice(realCount - cloneCount).forEach(function (c) {
        headFrag.appendChild(buffer(c));
      });
      track.insertBefore(headFrag, track.firstChild);

      var tailFrag = document.createDocumentFragment();
      originals.slice(0, cloneCount).forEach(function (c) {
        tailFrag.appendChild(buffer(c));
      });
      track.appendChild(tailFrag);

      cards = Array.prototype.slice.call(track.children);
      /* Cloned "Add" buttons are new DOM nodes with no click handler yet -
         the section's own inline script exposes this so clones work too. */
      if (window.wbHomeBindAdd) { window.wbHomeBindAdd(track); }
    }

    var nav = document.createElement('div');
    nav.className = 'wb-carousel-nav';
    var prev = arrow(-1);
    var next = arrow(1);
    var dots = document.createElement('div');
    dots.className = 'wb-carousel-dots';

    originals.forEach(function (card, i) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'wb-carousel-dot';
      d.setAttribute('aria-label', 'Go to item ' + (i + 1));
      d.addEventListener('click', function () { goTo(loop ? cloneCount + i : i); });
      dots.appendChild(d);
    });

    nav.appendChild(prev); nav.appendChild(dots); nav.appendChild(next);
    root.appendChild(nav);

    /* A card counts as "current" when its start edge sits at the viewport's
       start edge - that is what scroll-snap-align: start (set in the CSS for
       every one of these rows) actually snaps to, so this has to match it
       rather than guessing from the row's centre. Matching centre instead of
       start was the original bug: on load, with several cards visible, the
       card nearest the row's midpoint is the second or third one even though
       scrollLeft is genuinely 0, so the dots lit up on card 2 and "prev" had
       nowhere left to scroll to. */
    function currentDom() {
      var vLeft = viewport.getBoundingClientRect().left;
      var best = 0, bestD = Infinity;
      cards.forEach(function (c, i) {
        var d = Math.abs(c.getBoundingClientRect().left - vLeft);
        if (d < bestD) { bestD = d; best = i; }
      });
      return best;
    }

    function cardLeft(c) {
      return viewport.scrollLeft + (c.getBoundingClientRect().left - viewport.getBoundingClientRect().left);
    }

    /* The index we are heading to. Derived from scroll position when the user
       swipes, but held here so rapid taps on the arrows keep advancing instead
       of re-reading a scroll position that has not caught up yet. In loop
       mode this indexes into `cards` (clones + originals), not just the real
       products. */
    var idx = 0;

    function paint() {
      var real = loop ? (((idx - cloneCount) % realCount) + realCount) % realCount : idx;
      Array.prototype.forEach.call(dots.children, function (d, n) {
        d.classList.toggle('is-active', n === real);
      });
      /* Disabling by comparing idx to cards.length-1 only works when one card
         fills the viewport. Once several cards show at once (the resources
         and product rows), the last card's own left edge can never reach the
         viewport's left edge - there isn't enough row left to scroll it that
         far - so currentDom() never reports the final index and "next" would
         stay live forever. Reading the actual scroll position instead is
         correct regardless of how many cards are on screen at once. */
      if (loop) {
        prev.disabled = false;
        next.disabled = false;
      } else {
        /* The row's own left padding (Row side padding in the editor) is part
           of the resting scroll position: scroll-snap-align: start docks the
           first card's edge, padding included, against the viewport edge, so
           "no scroll left" reads as scrollLeft === that padding, not 0.
           Reading it straight off the track avoids hardcoding a number that
           would drift out of sync with the setting. */
        var startPad = parseFloat(getComputedStyle(track).paddingLeft) || 0;
        var max = viewport.scrollWidth - viewport.clientWidth;
        prev.disabled = viewport.scrollLeft <= startPad + 1;
        next.disabled = viewport.scrollLeft >= max - 1;
      }
    }

    function scrollToDom(n, instant) {
      var c = cards[n];
      if (!c) { return; }
      var left = cardLeft(c);
      /* Every one of these viewports sets scroll-behavior: smooth in CSS,
         and modern browsers honour that for a plain .scrollLeft assignment
         too, not just scrollTo() - so neither bypasses the animation. Only
         the explicit 'instant' behavior value does. That matters here: the
         wrap-around jump in settle() has to be invisible, not animated. */
      viewport.scrollTo({ left: left, behavior: (instant || reduce) ? 'instant' : 'smooth' });
    }

    function goTo(n) {
      idx = n;
      scrollToDom(n);
      paint();
    }

    /* After a scroll into the clone buffer settles, jump - with no animation,
       so it is invisible - to the matching position in the real range. This
       is the entire trick: the visitor scrolls past the "last" card and the
       real first card is already sitting there waiting; the wrap is never
       seen, and arrows never have to disable themselves at an edge. */
    function settle() {
      var d = currentDom();
      if (d < cloneCount) {
        idx = d + realCount;
        scrollToDom(idx, true);
      } else if (d >= cloneCount + realCount) {
        idx = d - realCount;
        scrollToDom(idx, true);
      } else {
        idx = d;
      }
      paint();
    }

    prev.addEventListener('click', function () { goTo(idx - 1); });
    next.addEventListener('click', function () { goTo(idx + 1); });

    var tick;
    viewport.addEventListener('scroll', function () {
      clearTimeout(tick);
      tick = setTimeout(function () {
        idx = currentDom();
        paint();
        if (loop) { settle(); }
      }, 80);
    }, { passive: true });

    window.addEventListener('resize', function () {
      clearTimeout(tick);
      tick = setTimeout(function () {
        idx = currentDom();
        if (loop) { scrollToDom(idx, true); }
        paint();
      }, 120);
    });

    if (loop) {
      idx = cloneCount;
      scrollToDom(idx, true);
    } else {
      idx = currentDom();
    }
    paint();
  }

  function carousels(scope) {
    var roots = (scope || document).querySelectorAll('.wb-home [data-wb-carousel]');
    Array.prototype.forEach.call(roots, carousel);
  }

  function start(scope) { reveal(scope); reels(scope); carousels(scope); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { start(); });
  } else {
    start();
  }

  /* The theme editor re-renders one section at a time - rescan just that one. */
  document.addEventListener('shopify:section:load', function (e) { start(e.target); });
})();
